import z from "zod";

//
// ProseMirror client ID.
//

export const prosemirrorClientId = z.union([z.string(), z.number()]);
export type ProseMirrorClientId = z.infer<typeof prosemirrorClientId>;
